import { render, staticRenderFns } from "./TopBusinesses.vue?vue&type=template&id=5e881477&scoped=true&"
import script from "./TopBusinesses.vue?vue&type=script&lang=js&"
export * from "./TopBusinesses.vue?vue&type=script&lang=js&"
import style0 from "./TopBusinesses.vue?vue&type=style&index=0&id=5e881477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e881477",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VDataTable})
